import { render, staticRenderFns } from "./composicion-levantamiento.vue?vue&type=template&id=9ddf0fd0&"
import script from "./composicion-levantamiento.vue?vue&type=script&lang=ts&"
export * from "./composicion-levantamiento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports